var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},[(_vm.data.isEnd)?_c('div',{staticClass:"end-img"},[_c('img',{attrs:{"src":"/static/images/budget/end.png","alt":""}})]):_vm._e(),_vm._l((_vm.infos),function(item,index){return _c('div',{key:index,staticClass:"info-item"},[_vm._v(" "+_vm._s(item.label)+"："+_vm._s(item.value)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }